import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { UserOutlined, LockOutlined, ArrowRightOutlined, SaveOutlined, ContactsOutlined } from '@ant-design/icons';
import { Button, message, Radio, Space } from 'antd';
import { user_data, user_login_state, user_role, w_labels, langs, chosen_lang, redir, surveys, _options, _questions, _questionsinprogress, _surveystatus, _firstrun_howto, _firstrun_sinstruction } from '../RecoilState';
import Text from './Text'


const Surveyinstructions = () => {

    const [labels, setLabels] = useRecoilState(w_labels);
    const [redirect, setRedirect] = useRecoilState(redir);
    const [surveystatus, setSurveystatus] = useRecoilState(_surveystatus);
    const [firstrunhowto, setFirstrunhowto] = useRecoilState(_firstrun_howto);
    const [firstrunsinstruction, setFirstrunsinstruction] = useRecoilState(_firstrun_sinstruction);

    // useEffect(() => {console.log(firstrunhowto)},[firstrunhowto])
    // useEffect(() => {console.log(firstrunsinstruction)},[firstrunsinstruction])

    const instnext = () => {
        if (firstrunsinstruction === true && firstrunhowto === "done") {
            setRedirect("survey")
            setSurveystatus("questions")
            // console.log("1")
        }
        else if (firstrunsinstruction === true && firstrunhowto === "false") {
            setRedirect("survey")
            setFirstrunhowto("show")
            // console.log("2")
        }


        // setRedirect("survey")
        // setSurveystatus("questions")
        // <Navigate to="/" />
    }

    return (
        <>
            <div className="header-accomodate">
                <div className="page-container mx-auto">
                    <div className="mb-5 pb-2 border-b-2">
                        <Text style={"large-gradient-heading"} value={labels[24]} />
                        <Text style={"text "} value={labels[25]} />
                    </div>
                    <div>
                        <div className="flex justify-start items-center flex-row h-24">
                            <img src={require('../assets/gi1.gif')} width={100} alt="lock gif" />
                            <Text style={"text"} value={labels[26]} />
                        </div>
                        <div className="flex justify-start items-center flex-row h-24">
                            <img src={require('../assets/gi2.gif')} width={100} alt="lock gif" />
                            <Text style={"text"} value={labels[27]} />
                        </div>
                        <div className="flex justify-start items-center flex-row h-24">
                            <img src={require('../assets/gi3.gif')} width={100} alt="lock gif" />
                            <Text style={"text"} value={labels[28]} />
                        </div>
                        <div className="flex justify-start items-center flex-row h-24">
                            <img src={require('../assets/gi4.gif')} width={100} alt="lock gif" />
                            <Text style={"text"} value={labels[29]} />
                        </div>
                        <div className="flex justify-center mt-5 mb-2">
                            <Button type="secondary" shape="round" size="large" onClick={() => instnext()}>
                                <div className="flex justify-center gap-x-4 items-center">
                                    {/* <Text style={"text"} value={labels[14]} /> */}
                                    <ArrowRightOutlined />
                                </div>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Surveyinstructions;